import { cx } from '~/utils';

import styles from './LogoText.module.scss';

interface LogoTextProps {
  multicolor?: boolean;
  logoName: 'Iris' | 'U' | 'Works' | 'AI';
  hideWordmark?: boolean;
  onClick?: () => void;
  style?: React.CSSProperties;
  className?: string;
}
export const LogoText = (props: LogoTextProps) => {
  const sweepAI = props.logoName === 'AI' ? 'SweepAI' : undefined;
  const U = props.logoName === 'U' ? true : false;
  return (
    <p
      className={cx(styles.wrapper, props.className)}
      onClick={(e) => {
        props.onClick?.();
      }}
    >
      {!sweepAI ? (
        <>
          <span>Exo&nbsp;</span>
          <span className={styles[props.logoName]}>{props.logoName}</span>
        </>
      ) : (
        <>
          <span>Sweep</span>
          <span className={styles[props.logoName]}>AI</span>
        </>
      )}
      {!props.hideWordmark && (
        <span className={cx(styles.nameCode, styles[props.logoName])}>
          {sweepAI || U ? '™' : '®'}
        </span>
      )}
    </p>
  );
};
